import { Subscription } from 'rxjs'

export class Subscriptions {
  private _active: boolean

  private readonly subList: Subscription[] = []

  public get active(): boolean {
    return this._active
  }

  public activate(): void {
    this._active = true
  }

  public set plusOne(v: Subscription) {
    this.subList.push(v)
  }

  constructor(activate = false) {
    this._active = activate
  }

  public unsubscribe(): void {
    this._active = false
    this.subList.forEach(sub => sub.unsubscribe())
  }
}
